import {
    getText as getTextImport,
    getProcessManagerErrorMessage as getProcessManagerErrorMessageImport,
    getAttentionText as getAttentionTextImport,
} from './localized/selectors'

const localized = {
    getText: state => getTextImport(state.localized),
    getProcessManagerErrorMessage: state => getProcessManagerErrorMessageImport(state.localized),
    getAttentionText: state => getAttentionTextImport(state.localized),
}

// eslint-disable-next-line
export const selectors = { localized }



// WEBPACK FOOTER //
// ./src/features/Backend/data/selectors.js